import { render, staticRenderFns } from "./EmailLogin.vue?vue&type=template&id=3bb6ff45&scoped=true&"
import script from "./EmailLogin.vue?vue&type=script&lang=js&"
export * from "./EmailLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb6ff45",
  null
  
)

export default component.exports